import TaxonomyWidget from '../lib/search/TaxonomyWidget.js';

export default {
    dependencies: ['$element', 'trackingservice'],
    callable(ele, trackingservice) {
        // eslint-disable-next-line no-new
        const widget = new TaxonomyWidget(
            ele.querySelector('[data-taxonomy-root]')
        );
        ele.widget = widget; // FIXME!!!

        ele.addEventListener('keydown', event => {
            if (
                event.target.matches("[type='checkbox']") &&
                event.which === 13 /* Enter */
            ) {
                event.target.click();
                event.preventDefault();
                event.stopPropagation();
            }
        });

        ele
            .querySelector('[data-taxonomy-root]')
            .addEventListener('change', trackFilterSelection);
        function trackFilterSelection(event) {
            const checkbox = event.target;
            if (checkbox.checked) {
                trackingservice.trackEventObject({
                    analyticsName: `navigation.filter-by-${checkbox.name.replace(
                        /_/g,
                        ''
                    )}.click`,
                    stringValue: `${checkbox.name}:${checkbox.value}`,
                });
            }
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/taxonomy.js